<template>
  <div style="margin-top: -7vh;">
    <footer
      class="sticky-footer bg-white"
      id="appFooter"
    >
      <div class="container my-auto">
        <div class="copyright text-center my-auto">
          <span class="spanMobile">Copyright &copy; Veritas Training Management System 2019</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
  };
</script>

<style scoped>
    @media screen and (max-width: 575px) {
       .spanMobile{
            font-size: 10px !important;
        }
    }


</style>